<template>
  <div>
    <b-modal :width="1600" v-model="modalBigImageQuestion.activeModalBigImageQuestion">
      <ModalBigImageQuestion :modalBigImageQuestion="modalBigImageQuestion" />
    </b-modal>
    <!-- tag pour les reponses facultatives -->
    <b-tag
    type="is-warning"
    v-if="question.optional && !question.relation_section"
    >{{ $t("optional.instructions") }}</b-tag
    >
    <!-- tag maximun de choix pour les reponses multiples -->
    <b-tag
    type="is-danger"
    v-if="question.element_type == 'checkboxes' && question.maxchoice > 0"
    >{{ question.maxchoice }}
    {{ $tc("maxchoice.instructions", question.maxchoice) }}</b-tag
    >
    <div>
      <div
      v-if="
      this.$store.state.sondage.languagesAdmin !== null &&
      this.$store.state.sondage.languagesAdmin.includes(
        choosenLanguageClient
        )
        "
        >
        <h4
        v-if="choosenLanguageClient === 'fr'"
        style="font-size: 16px; font-weight: bold"
        class="title is-5"
        >
        {{ index + 1 }} / {{ question.entitled }}
      </h4>
      <h4
      v-if="choosenLanguageClient === 'en'"
      style="font-size: 16px; font-weight: bold"
      class="title is-5"
      >
      {{ index + 1 }} / {{ question.entitled_en }}
    </h4>
    <h4
    v-if="choosenLanguageClient === 'es'"
    style="font-size: 16px; font-weight: bold"
    class="title is-5"
    >
    {{ index + 1 }} / {{ question.entitled_es }}
  </h4>
  <h4
  v-if="choosenLanguageClient === 'de'"
  style="font-size: 16px; font-weight: bold"
  class="title is-5"
  >
  {{ index + 1 }} / {{ question.entitled_de }}
</h4>
<div class="illus_question columns" v-if="question.file_url">
  <div
  class="column is-12-mobile-only is-4-tablet is-3-desktop-only is-3-fullhd"
  >
  <img :src="question.file_url" @click="popupImage(question.file_url)" />
</div>
</div>
<!-- bouton "cet ordre me convient" pour les choix ordonnes -->
<div
style="margin-bottom: 10px; font-size:12px;"
v-if="question.element_type == 'orderedChoices'"
>
{{ $t("orderedChoices.instructions") }}
<button
v-if="!orderIsOk"
style="border-radius:0px; border:1px solid #51a1db; color: #51a1db; vertical-align:middle;"
class="button is-outlined is-small"
type="button"
@click="updateOrder"
>
{{ $t("question.ordreConvient") }}
</button>
<b-icon
v-if="orderIsOk"
type
pack="fas"
icon="check fa-check"
size="is-small"
></b-icon>
</div>
<div
style="margin-bottom:20px;height:1px;width:100%;background:#dddbdc "
/>
<div class="is-clearfix"></div>

<!-- ## PROPOSITIONS  ## -->
<!-- <div class="bloc_propositions"></div> -->
<!-- choix unique -->
<table style="margin-left:0px;" v-if="question.element_type == 'radio'">
  <tr v-for="(answer, index2) in question.answers" :key="index2">
    <proposition
    :index="index"
    :question="question"
    :answer="answer"
    :disabledProp="disabled"
    @update-radio="updateRadio"
    @update-field="updateRadioText"
    ref="propositionsRadio"
    ></proposition>
  </tr>
</table>

<!-- choix multiple -->
<table
style="margin-left:0px;"
class="container"
v-if="question.element_type == 'checkboxes'"
>
<tr v-for="(answer, index2) in question.answers" :key="index2">
  <proposition
  :question="question"
  :answer="answer"
  :disabledProp="disabled"
  @update-check="updateCheckboxes"
  v-model="checkedBoxes"
  :checked="checked"
  ref="propositionsCheckbox"
  ></proposition>
</tr>
</table>

<!-- choix ordonnes -->
<table
style="max-width: 480px"
v-if="question.element_type == 'orderedChoices'"
>
<draggable
class="list"
:list="question.answers"
@change="updateOrder()"
>
<div
class="list-item ordered"
v-for="answer in question.answers"
:key="answer.id"
>
<input
type="checkbox"
class="orderedcheckbox"
:name="'q' + question.id"
:value="answer.id"
:id="'id' + answer.id"
:checked="checked"
/>

<b-icon
style="color: #bdbeba;"
pack="fas"
icon="sort"
size="is-small"
></b-icon>

<!-- translations -->
<label
v-if="choosenLanguageClient === 'fr'"
class="ordered"
:for="'id' + answer.id"
@click.prevent
>{{ answer.entitled }}</label
>
<label
v-if="choosenLanguageClient === 'en'"
class="ordered"
:for="'id' + answer.id"
@click.prevent
>{{ answer.entitled_en }}</label
>
<label
v-if="choosenLanguageClient === 'es'"
class="ordered"
:for="'id' + answer.id"
@click.prevent
>{{ answer.entitled_es }}</label
>
<label
v-if="choosenLanguageClient === 'de'"
class="ordered"
:for="'id' + answer.id"
@click.prevent
>{{ answer.entitled_de }}</label
>
<input
type="checkbox"
class="orderedcheckbox"
:name="'q' + question.id"
:value="answer.id"
:id="'id' + answer.id"
:checked="checked"
/>
</div>
</draggable>
</table>
<!-- liste deroulante  -->
<div>
  <p v-if="question.element_type == 'select'">
    <select
    id="select-liste-deroulante"
    :name="'q' + question.id"
    @change="updateSelect"
    >
    <option style="font-size:12px; color:grey">{{
      $t("question.listeChoisir")
    }}</option>
    <!-- translation fr -->
    <option
    v-if="choosenLanguageClient === 'fr'"
    v-for="(answer, index3) in question.answers"
    :key="index3"
    :value="answer.id"
    >
    {{
      answer.entitled
      ? answer.entitled
      : $t("question.autre.label")
    }}
  </option>
  <!-- translation en -->
  <option
  v-if="choosenLanguageClient === 'en'"
  v-for="(answer, index3) in question.answers"
  :key="index3"
  :value="answer.id"
  >
  {{
    answer.entitled_en
    ? answer.entitled_en
    : $t("question.autre.label")
  }}
</option>
<!-- translation es -->
<option
v-if="choosenLanguageClient === 'es'"
v-for="(answer, index3) in question.answers"
:key="index3"
:value="answer.id"
>
{{
  answer.entitled_es
  ? answer.entitled_es
  : $t("question.autre.label")
}}
</option>
<option
v-if="choosenLanguageClient === 'de'"
v-for="(answer, index3) in question.answers"
:key="index3"
:value="answer.id"
>
{{
  answer.entitled_de
  ? answer.entitled_de
  : $t("question.autre.label")
}}
</option>
</select>
</p>
<!-- gestion des reponses de type "autre" -->
<div
style="margin-top: 10px"
v-if="question.element_type == 'select' && check"
>
<span>{{ $t("question.votre.proposition") }}{{ ": " }}</span>
<input
maxlength="100"
style="max-width: 320px"
type="text"
:name="'p' + question.id"
:id="'id' + this.indexSelect"
:disabled="!check"
v-model="text"
/>
</div>
</div>
<!-- notation etoile -->
<div v-if="question.element_type == 'notation'">
  <star-rating
  inactive-color="#e1e1e1"
  v-bind:star-size="25"
  v-model="selectedNote[index]"
  :rounded-corners="false"
  @rating-selected="updateNotation(selectedNote[index])"
  :show-rating="false"
  ></star-rating>
  <input
  style="display: none"
  type="text"
  v-model="notation"
  maxlength="1"
  :name="'q' + question.id"
  />
</div>
<!-- texte libre -->
<div v-if="question.element_type == 'content'">
  <textarea
  style="font-size:12px;"
  :placeholder="$t('input.text-placeholder')"
  class="myTextarea"
  maxlength="500"
  :name="'q' + question.id"
  rows="4"
  @input="updateContent"
  ></textarea>
</div>
</div>
<div v-else style="color: red; text-align: center">
  {{ $t("question.no-translation") }}
</div>
</div>
</div>
</template>

<script>
  import proposition from '@/components/formulaire/formulaire_layouts/proposition'
  import ModalBigImageQuestion from '@/components/sondage/components/ModalBigImageQuestion'
  import draggable from 'vuedraggable'
  import StarRating from 'vue-star-rating'
  import { mapGetters } from 'vuex'
  export default {
    props: {
      question: '',
      index: ''
    },
    components: { proposition, draggable, StarRating,ModalBigImageQuestion },
    data () {
      return {
        disabled: true,
        checkedBoxes: [],
        autre_id: '',
        orderIsOk: false,
        checked: false,
        selectedNote: [],
        reloaded: 0,
        texte: '',
        text: '',
        check: false,
        indexSelect: null,
        notation: 0
      }
    },
    computed: {
      ...mapGetters([
        'type_formulaire',
        'sections',
        'steps',
        'modalBigImageQuestion',
        'choosenLanguageClient'
        ])
    },
    watch: {
      reloaded () {
        if (this.reloaded > 0) {
          (this.disabled = true),
          (this.orderIsOk = false),
          (this.selectedNote = []),
          (this.checkedBoxes = []),
          (this.checked = false),
          (this.texte = ''),
          (this.text = ''),
          (this.check = false),
          (this.indexSelect = null),
          (this.autre_id = '')
          if (this.$refs.propositionsRadio) {
            this.$refs.propositionsRadio.forEach(el => {
              (el.text = ''), (el.check = false)
            })
          }
          if (this.$refs.propositionsCheckbox) {
            this.$refs.propositionsCheckbox.forEach(el => {
              (el.text = ''), (el.check = false)
            })
          }
        }
      }
    },
    methods: {
      popupImage (url) {
        this.sendMessageToParent('scrollToTop')
        this.$store.commit('MODAL_BIGIMAGEQUESTION', {
           urlBigImageQuestion: url,
           activeModalBigImageQuestion: true
        })
      },
      updateIf (arg) {
        if (arg) {
          this.$store.commit('UDPATE_SHOW_NEXT', {
            type: this.type_formulaire,
            response: !!arg,
            index: this.question.order
          })
        }
      },
      updateRadio (proposition, toggle, text, condtionalSection) {
        this.$store.commit(
          'UPDATE_RELATION_SECTION',
          this.question.relation_section
          )
        this.$store.commit('RESET_STEPS_LENGHT', this.question.relation_section)
        this.$store.commit('UPDATE_RADIO_ANSWER_CONDTIONAL_SECTION', {
          conditionalSection: condtionalSection,
          data: this.sections
        })
        this.$store.commit(
          'UPDATE_QUESTION_CURRENT_SECTION',
          this.question.current_section
          )
        this.disabled = toggle
        this.updateIf(proposition === 'radio' || text.length)
      },
      updateRadioText (text, condtionalSection) {
        this.$store.commit('UPDATE_RADIO_ANSWER_CONDTIONAL_SECTION', {
          conditionalSection: condtionalSection,
          data: this.sections
        })
        this.$store.commit(
          'UPDATE_RELATION_SECTION',
          this.question.relation_section
          )
        if (
          this.$store.state.question.type_formulaire === 'simple' &&
          this.$store.state.client.steps.nowStep ===
          this.$store.state.client.steps.stepsLength.length
          ) {
          this.$store.commit('UPDATE_AUTHORIZED_FORM', true)
      }
      this.updateIf(text.length)
    },
    generateCheckedBoxesArray (id, proposition) {
      // si l'id est deja dans le tableau des cases cochées...
      if (this.checkedBoxes.includes(id)) {
        var remove = this.checkedBoxes.findIndex(el => {
          return el == id
        })
        // on le retire
        this.checkedBoxes.splice(remove, 1)
      } else {
        // sinon on l'ajoute
        this.checkedBoxes.push(id)
        if (proposition == 'content') {
          this.autre_id = id
        }
      }
    },
    testAutre (test, text, type) {
      if (this.question.autre == 1) {
        // gestion du champ
        if (text.length) {
          if (
            this.$store.state.question.type_formulaire === 'simple' &&
            this.$store.state.client.steps.nowStep ===
            this.$store.state.client.steps.stepsLength.length
            ) {
            this.$store.commit('UPDATE_AUTHORIZED_FORM', true)
        }
        this.texte = text
      } else {
          // si on est en train d'effacer le champ
        if (type != 'checkbox') {
          this.texte = text
        }
      }
        // si la case "autre" est coché, donc que le tableau contient son id
      if (this.checkedBoxes.includes(this.autre_id)) {
        this.disabled = false
      } else {
        this.disabled = true
      }
      if (this.disabled == false) {
        if (this.texte.length != 0) {
          test.push('ok')
        } else {
          this.$store.commit('UPDATE_AUTHORIZED_FORM', false)
          test.push('error')
        }
      }
    } else {
      test.push('discard')
    }
  },
  testOptional (test) {
    if (this.question.optional == 1) {
      test.push('ok')
    } else {
      if (this.checkedBoxes.length == 0) {
        test.push('error')
      } else {
        test.push('discard')
      }
    }
  },
  sendMessageToParent (taskToDo) {
    let message = {
      task: taskToDo
    }
    window.top.postMessage(message, '*')
  },
  testMaxChoice (test) {
    if (this.question.maxchoice > 0) {
      if (this.checkedBoxes.length <= this.question.maxchoice) {
        this.$store.commit('ERROR_MAX_CHECKBOXES', false)
        test.push('ok')
      } else {
        if (this.checkedBoxes.length > this.question.maxchoice) {
          this.$store.commit('ERROR_MAX_CHECKBOXES', true)
          this.sendMessageToParent('scrollToTop')
          test.push('error')
          this.$buefy.toast.open({
            type: 'is-danger',
            position: 'is-top',
            message: this.$i18n.t('toast.maxchoice_depasse')
          })
        }
      }
    } else {
      test.push('discard')
    }
  },
  updateCheckboxes (proposition, id, text, check, type) {
    this.$store.commit('RESET_STEPS_LENGHT', null)
    this.$store.commit(
      'UPDATE_RELATION_SECTION',
      this.question.relation_section
      )
      // premierement on met a jour le tableau des checkboxes cochés
    if (type == 'checkbox') {
        // au cochage d'une case
      this.generateCheckedBoxesArray(id, proposition)
    }

      // maintenant on teste toutes les options
    var test = []
    this.testAutre(test, text, type)
    this.testOptional(test)
    this.testMaxChoice(test)
    if (test.includes('error')) {
      this.$store.commit('UPDATE_AUTHORIZED_FORM', false)
      this.$store.commit('UDPATE_SHOW_NEXT', {
        type: this.type_formulaire,
        response: false,
        index: this.question.order
      })
    } else {
      if (
        this.$store.state.question.type_formulaire === 'simple' &&
        this.$store.state.client.steps.nowStep >=
        this.$store.state.question.questions.length
        ) {
        this.$store.commit('UPDATE_AUTHORIZED_FORM', true)
    }
    if (this.type_formulaire === 'section') {
      if (
        this.steps.nowStep - 1 ===
        this.sections[this.sections.length - 1].questions[
          this.sections[this.sections.length - 1].questions.length - 1
          ].order
        ) {
        this.$store.commit('UPDATE_AUTHORIZED_FORM', true)
    } else {
      this.$store.commit('UPDATE_AUTHORIZED_FORM', false)
    }
  }
  this.$store.commit('UDPATE_SHOW_NEXT', {
    type: this.type_formulaire,
    response: true,
    index: this.question.order
  })
}
},
updateOrder () {
  if (
    this.$store.state.question.type_formulaire === 'simple' &&
    this.$store.state.client.steps.nowStep >=
    this.$store.state.client.steps.stepsLength.length
    ) {
    this.$store.commit('UPDATE_AUTHORIZED_FORM', true)
}
      // si c'est une section on vérifie si on est à la fin du sondage pour afficher le bouton 'envoyer le formulaire'
if (this.type_formulaire === 'section') {
  if (
    this.steps.nowStep - 1 ===
    this.sections[this.sections.length - 1].questions[
      this.sections[this.sections.length - 1].questions.length - 1
      ].order
    ) {
    this.$store.commit('UPDATE_AUTHORIZED_FORM', true)
} else {
  this.$store.commit('UPDATE_AUTHORIZED_FORM', false)
}
}
this.orderIsOk = true
this.checked = true
this.$store.commit('UDPATE_SHOW_NEXT', {
  type: this.type_formulaire,
  response: true,
  index: this.question.order
})
},
updateSelect (e) {
  this.$store.commit('RESET_STEPS_LENGHT', null)
  this.$store.commit(
    'UPDATE_RELATION_SECTION',
    this.question.relation_section
    )
  if (
    this.$store.state.question.type_formulaire === 'simple' &&
    this.$store.state.client.steps.nowStep >=
    this.$store.state.client.steps.stepsLength.length
    ) {
    this.$store.commit('UPDATE_AUTHORIZED_FORM', true)
}
      // si c'est une section on vérifie si on est à la fin du sondage pour afficher le bouton 'envoyer le formulaire'
if (this.type_formulaire === 'section') {
  if (
    this.steps.nowStep - 1 ===
    this.sections[this.sections.length - 1].questions[
      this.sections[this.sections.length - 1].questions.length - 1
      ].order
    ) {
    this.$store.commit('UPDATE_AUTHORIZED_FORM', true)
} else {
  this.$store.commit('UPDATE_AUTHORIZED_FORM', false)
}
}
      // on vérifie si dans la question on a la valeur 1 à "autre"
if (this.question.autre === 1) {
  for (let i = 0; i < this.question.answers.length; i++) {
    if (i + 1 === e.target.options['selectedIndex']) {
      this.check = true
      this.question.answers.map(x => {
        if (x.entitled === '') this.indexSelect = x.id
      })
    } else {
      this.check = false
    }
  }
}
this.updateIf(e.target.options['selectedIndex'])
},
updateNotation (rating) {
  this.notation = rating
  this.$store.commit('RESET_STEPS_LENGHT', null)
  this.$store.commit(
    'UPDATE_RELATION_SECTION',
    this.question.relation_section
    )
  if (
    this.$store.state.question.type_formulaire === 'simple' &&
    this.$store.state.client.steps.nowStep >=
    this.$store.state.client.steps.stepsLength.length
    ) {
    this.$store.commit('UPDATE_AUTHORIZED_FORM', true)
}
      // si c'est une section on vérifie si on est à la fin du sondage pour afficher le bouton 'envoyer le formulaire'
if (this.type_formulaire === 'section') {
  if (
    this.steps.nowStep - 1 ===
    this.sections[this.sections.length - 1].questions[
      this.sections[this.sections.length - 1].questions.length - 1
      ].order
    ) {
    this.$store.commit('UPDATE_AUTHORIZED_FORM', true)
} else {
  this.$store.commit('UPDATE_AUTHORIZED_FORM', false)
}
}
this.$store.commit('UDPATE_SHOW_NEXT', {
  type: this.type_formulaire,
  response: true,
  index: this.question.order
})
},
updateContent (e) {
  this.updateIf(e.target.value.length > 0)
  if (
    this.$store.state.question.type_formulaire === 'simple' &&
    this.$store.state.client.steps.nowStep >=
    this.$store.state.client.steps.stepsLength.length
    ) {
    this.$store.commit('UPDATE_AUTHORIZED_FORM', true)
}
      // si c'est une section on vérifie si on est à la fin du sondage pour afficher le bouton 'envoyer le formulaire'
if (this.type_formulaire === 'section') {
  if (
    this.steps.nowStep - 1 ===
    this.sections[this.sections.length - 1].questions[
      this.sections[this.sections.length - 1].questions.length - 1
      ].order
    ) {
    this.$store.commit('UPDATE_AUTHORIZED_FORM', true)
} else {
  this.$store.commit('UPDATE_AUTHORIZED_FORM', false)
}
}
}
}
}
</script>

<style scoped>
  .illus_question img {
    height: 150px;
    width: auto;
    max-width: 100%;
  }

/* CUSTOM TEXTAREA */
.myTextarea {
  padding: 5px;
  width: 100%;
}

/* CUSTOM ORDERED*/
.orderedcheckbox {
  cursor: move;
  visibility: hidden;
  padding: 0px;
}

.sortable-chosen {
  background: #e1f3ff;
  color: black;
}

.ordered {
  cursor: move;
}

.list-item {
  display: block;
  font-weight: normal;
  padding: 0.7em 1em 0.7em 0em;
}
#select-liste-deroulante {
  -webkit-appearance: none;
  -moz-appearance: none;
  background: #ffffff;
  color: rgb(58, 58, 58);
  background-image: url("data:image/svg+xml;utf8,<svg fill='black' height='24' viewBox='0 0 24 24' width='24' xmlns='http://www.w3.org/2000/svg'><path d='M7 10l5 5 5-5z'/><path d='M0 0h24v24H0z' fill='none'/></svg>");
  background-repeat: no-repeat;
  background-position-x: 100%;
  background-position-y: 50%;
  padding: 6px;
  padding-right: 2rem;
  cursor: pointer;
  border: 0.8px solid #dddddd;
}
select option {
  color: #000;
}
</style>



// WEBPACK FOOTER //
// src/components/formulaire/formulaire_layouts/Question.vue